import { useKeycloak } from '../auth/keycloak';
import { RealmRoles } from '../constants';

enum KeycloakResourceType {
  RealmManagement = 'realm-management',
  Account = 'account',
}

const useAuthService = () => {
  const { keycloak } = useKeycloak();

  const userHasRole = (roles: RealmRoles[]): boolean =>
    roles.some(
      (role) =>
        keycloak?.hasRealmRole(role) ||
        keycloak?.hasResourceRole(role, KeycloakResourceType.RealmManagement) ||
        keycloak?.hasResourceRole(role, KeycloakResourceType.Account)
    );

  return {
    userHasRole,
    logOut: keycloak.logout,
    userInfo: {
      name: keycloak.tokenParsed?.name,
    },
  };
};

export default useAuthService;
